var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dib bsb w100 h100 vam count-down unselect csp",attrs:{"disabled":_vm.lock},on:{"click":_vm.active}},[_vm._v(_vm._s(_vm._f("countFormat")(_vm.count,_vm.format))+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }